import { render, staticRenderFns } from "./distributionLogs.vue?vue&type=template&id=1a67730f&"
import script from "./distributionLogs.vue?vue&type=script&lang=js&"
export * from "./distributionLogs.vue?vue&type=script&lang=js&"
import style0 from "./distributionLogs.vue?vue&type=style&index=0&id=1a67730f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports